import { bucketConfig, BucketSize } from 'app/agriculture/queries/snapshots/config/bucketConfig';
import { Interval, ViewMode } from 'app/agriculture/AgTimeline/types';
import { isPast } from 'date-fns';

interface Params {
    bucketSize: BucketSize;
    cursorTime: Date;
    timelineInterval: Interval<Date>;
    timelineViewMode: keyof typeof ViewMode;
}

/**
 * Returns an array of all the buckets in the current timeline view
 * Sorted by proximity to cursor time
 */
export function getSortedIntervalBucketTimestamps({
    bucketSize,
    cursorTime,
    timelineInterval,
    timelineViewMode,
}: Params) {
    const {
        startOfBucket,
        eachBucketOfInterval,
        differenceInBuckets,
        viewModesThatFetchAllBuckets,
    } = bucketConfig[bucketSize];

    const shouldPrepopulateAllBucketsInTimelineInterval = viewModesThatFetchAllBuckets.some(
        (viewMode) => timelineViewMode === viewMode,
    );

    if (!shouldPrepopulateAllBucketsInTimelineInterval) return [startOfBucket(cursorTime)];

    // get all the buckets in the interval
    const bucketTimestamps = eachBucketOfInterval(timelineInterval);

    return (
        bucketTimestamps
            // filter out any bucket dates not in the past
            .filter((date) => isPast(date))
            // sort by temporal proximity to cursorTime
            .sort(
                (date1, date2) =>
                    Math.abs(differenceInBuckets(cursorTime, date1)) -
                    Math.abs(differenceInBuckets(cursorTime, date2)),
            )
    );
}
